import { useCart } from '../../context/CartContext';
import { formatPrice } from '../../utils/helpers';
import './CartSummary.css';

const CartSummary = () => {
  const { cartTotal } = useCart();
  // Design shows Shipping Free
  const shippingCost = 0;
  const total = cartTotal + shippingCost;

  return (
    <div className="cart-summary">
      <h3>Order Summary</h3>
      <div className="cart-summary-divider"></div>

      <div className="cart-summary-row subtotal">
        <span>Subtotal</span>
        <span>{formatPrice(cartTotal)}</span>
      </div>

      <div className="cart-summary-row shipping">
        <span>Shipping</span>
        <span>Free</span>
      </div>

      <div className="cart-summary-divider-light"></div>

      <div className="cart-summary-row total">
        <span>Total</span>
        <span>{formatPrice(total)}</span>
      </div>
    </div>
  );
};

export default CartSummary;
